import * as Yup from "yup";
import { useFormik } from "formik";
import { V3Button } from "../Button";
import { RightAlignPanel } from "../ReusableStyledComponents/RightAlignPanel";
import { V3BodyGrey35 } from "../ReusableStyledComponents/V3BodyGrey35";
import { V3ModalBase } from "../V3ModalBase";
import { VerticalSpacing } from "../VerticalSpacing";
import { V3TextInput } from "../TextInput/V3TextInput";
import { V3ButtonColor } from "../Button/V3Button.types";

interface V3ModalUpdateSlugProps {
    modalOpen: boolean;
    onCloseHandler: () => void;
    onPasswordUpdate: (password: string) => void;
    contentTarget: string;
}

export const V3ModalUpdatePassword = ({ modalOpen, contentTarget, onCloseHandler, onPasswordUpdate }: V3ModalUpdateSlugProps) => {
    const formik = useFormik<{ password: string }>({
        enableReinitialize: true,
        initialValues: {
            password: ""
        },
        onSubmit: async (data) => {
            onPasswordUpdate(data.password);
            onCloseHandler();
        },
        validationSchema: Yup.object().shape({
            password: Yup.string().trim().ensure().min(1, "Password must be at min 1 characters")
        })
    });

    return (
        <V3ModalBase isOpen={modalOpen} onClose={onCloseHandler} title={"Set a password"}>
            <VerticalSpacing bottom={32}>
                <V3BodyGrey35>Anyone with this password can view your {contentTarget}.</V3BodyGrey35>
            </VerticalSpacing>
            <form onSubmit={formik.handleSubmit}>
                <V3TextInput
                    type="password"
                    name="password"
                    label="Password"
                    placeholder={"Enter password"}
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={formik.errors.hasOwnProperty("password") && formik.touched.hasOwnProperty("password") ? formik.errors.password : undefined}
                    onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === "Enter") {
                            formik.handleSubmit();
                        }
                    }}
                />
                <VerticalSpacing top={24}>
                    <RightAlignPanel>
                        <div>
                            <V3Button text="Cancel" color={V3ButtonColor.secondary} onClick={onCloseHandler} />
                        </div>
                        <div>
                            <V3Button text="Save" type="submit" />
                        </div>
                    </RightAlignPanel>
                </VerticalSpacing>
            </form>
        </V3ModalBase>
    );
};
